import { z } from 'zod';

/**
 * What a product in the catalogue sells (D9a).
 *
 * `subscription` is a tier for a period — the plans P23 built, granting a
 * `user_entitlements` row. `fee` is a **one-off**: paid once, for one thing,
 * and it grants no entitlement at all; what it unlocks is the business of the
 * module named by its {@link FeePurpose}. Both are sold through the same two
 * doors (the app stores via RevenueCat, and the staff-recorded direct order),
 * which is the whole reason a fee is a product rather than a second catalogue.
 */
export const PRODUCT_KINDS = ['subscription', 'fee'] as const;

export const ProductKindSchema = z.enum(PRODUCT_KINDS);

export type ProductKind = (typeof PRODUCT_KINDS)[number];

const KIND_SET: ReadonlySet<string> = new Set(PRODUCT_KINDS);

export function isProductKind(value: string): value is ProductKind {
  return KIND_SET.has(value);
}
